export const TrustpilotRatesUrlApi =
  'https://api.trustpilot.com/v1/business-units/5f2a7644d9d39500016dc5b6?apikey=OSkkmAGxWAZr9Th55JHOUXtEBLvIhOOv';
